"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _theme = require("../utils/theme");
var _styledComponents = require("styled-components");
var _core = require("@qwkin/core");
var _excluded = ["theme", "s3Key", "s3Bucket", "onClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var withS3Downloader = function withS3Downloader(Component) {
  var S3Downloader = function S3Downloader(_ref) {
    var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
      s3Key = _ref.s3Key,
      s3Bucket = _ref.s3Bucket,
      _onClick = _ref.onClick,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      downloadedFile = _useState2[0],
      setDownloadedFile = _useState2[1];
    var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      failDownload = _useState4[0],
      setFailDownload = _useState4[1];
    (0, _react.useEffect)(function () {
      if (s3Key && s3Bucket) {
        _core.API.fromS3(s3Bucket, s3Key).then(function (file) {
          setDownloadedFile(file);
        })["catch"](function (e) {
          setDownloadedFile(null);
          setFailDownload(true);
        });
      }
    }, [s3Key, s3Bucket]);
    return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
      theme: theme
    }, downloadedFile && /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
      onClick: function onClick() {
        return _onClick(downloadedFile);
      }
    }, props)), failDownload && /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
      disabled: true,
      fail: true
    }, props)));
  };
  return S3Downloader;
};
var _default = exports["default"] = withS3Downloader;